module.exports = __webpack_public_path__ + "images/category_lp/smartphone/point3_a2e655ee9f83115a5ce437f886eaf94e.png";